import { render, staticRenderFns } from "./tournament.vue?vue&type=template&id=0b38bce8&scoped=true"
import script from "./tournament.vue?vue&type=script&lang=js"
export * from "./tournament.vue?vue&type=script&lang=js"
import style0 from "./tournament.vue?vue&type=style&index=0&id=0b38bce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38bce8",
  null
  
)

export default component.exports